/**
 * Block is used on framework/vc-elements/block-complaints.php
 *
 * @returns {{locationComplaintFlowchart: string, selectLocation(): void, locationLoaded: boolean, locationId: string, locationComplaintPolicy: string}}
 */
export default () => ({
    locationId: '',
    locationLoaded: false,
    locationComplaintPolicy: '',
    locationComplaintFlowchart: '',
    careHomePolicy: '',
    homeCarePolicy: '',

    selectLocation(locationType) {
        let ref = this;
        this.locationLoaded = false;
        this.careHomePolicy = false;
        this.homeCarePolicy = false;

        if ('care-home' == locationType) {
            this.careHomePolicy = true;
            this.homeCarePolicy = false;
        }

        if ('home-care' == locationType) {
            this.careHomePolicy = false;
            this.homeCarePolicy = true;
        }

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_complaints_select_home&post_id=' + this.locationId
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                ref.locationLoaded = true;
                ref.locationComplaintPolicy = data.data.locationComplaintPolicy;
                ref.locationComplaintFlowchart = data.data.locationComplaintFlowchart;
            })
            .catch((error) => {
                console.error(error);
            });
    }
})